(() => {
  const init = () => {
    const header = document.querySelector('.site-header.halo-header-01.header-sticky');
    if (!header) return;
    let pending = false;
    const update = () => {
      if (pending) return;
      pending = true;
      requestAnimationFrame(() => {
        pending = false;
        const value = header.classList.contains('is-sticky') ? `${Math.ceil(header.getBoundingClientRect().height)}px` : '0px';
        if (document.body.style.paddingTop !== value) document.body.style.paddingTop = value;
      });
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    new MutationObserver(update).observe(header, { attributes: true, attributeFilter: ['class'] });
    update();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
